/*!
 * doTERRA Web-UI
 * http://www.doterra.com
 *
 * Copyright 2019 doTERRA Holdings, LLC
 * All Rights Reserved
 */
import React from 'react';
import { text } from '../utils/i18n';


/*******************************/
/** Button(s)                 **/
/*******************************/
export const Button = (props) => {
    const { id, classes, disabled, onClick, text, cssStyles, type , ariaLabel } = props;
    return (
        <button tabIndex="0" role="button" id={id} type={type ? type : "button"} className={classes} disabled={disabled} onClick={onClick} style={cssStyles} aria-label={ariaLabel}>
            {text}
            <i className="spinner spinner--white spinner--sm" />
        </button>
    );
};


export const PrimaryButton = (props) => {
    let { id, disabled, onClick, text, classes } = props;
    classes = 'btn btn-primary' + (classes && classes.length > 0 ? ` ${classes}` : '');
    return <Button tabIndex="0" role="button" id={id} classes={classes} onClick={onClick} disabled={disabled} text={text}/>;
};

export const SecondaryButton = (props) => {
    let { id, disabled, onClick, text, classes } = props;
    classes = 'btn btn-secondary' + (classes && classes.length > 0 ? ` ${classes}` : '');
    return <Button tabIndex="0" role="button" id={id} classes={classes} onClick={onClick} disabled={disabled} text={text}/>;
};

// TODO: remove this soon; replace with PrimaryButton
export const StandardButton = (props) => {
    let { id, disabled, onClick, text, classes } = props;
    classes = 'btn btn-primary' + (classes && classes.length > 0 ? ` ${classes}` : '');
    return <Button tabIndex="0" role="button" id={id} classes={classes} onClick={onClick} disabled={disabled} text={text}/>;
};

export const SubmitButton = (props) => {
    const { id, disabled, onClick, text, classes } = props;
    return <Button tabIndex="0" role="button" id={id} classes={classes} type="submit" onClick={onClick} disabled={disabled} text={text}/>;
};


/*******************************/
/** Icon(s)                   **/
/*******************************/
const ICON_SIZES = {
    'tiny': 'xs',
    'small': 'sm',
    'medium': 'md',
    'large': 'lg',
    'extraLarge':'xl'
};

export const Icon = (props) => {
    const { name, size, cssStyles, onClick,label} = props;
    const cssTransBtn = {
        border:'none',
        background:'none',
        padding: 0
    };
    let iSize = size !== undefined ? ICON_SIZES[size] : null;
    if (!iSize) {
        iSize = 'md';
    }
    return onClick ? <button role="button" tabIndex="0" data-testid="icon-element" aria-label={`${label ? label : '' }`} className={`icon--${name} icon--${iSize}`} style={{...cssStyles, ...cssTransBtn}} onClick={onClick}/>
                        : <i data-testid="icon-element" className={`icon--${name} icon--${iSize}`} style={cssStyles} onClick={onClick}/>;
};


/*******************************/
/** Link(s)                   **/
/*******************************/
export const Link = (props) => {
    const { id, value, key, onClick, classNames } = props;
    const displayText = value && value.length > 0 ? value : text(key);
    
    const handleClicked = () => {
        if (onClick) {
            onClick();
        }
    };

    return (
        <a id={id} tabIndex={0} className={classNames} onClick={() => handleClicked()}>{displayText}</a>
    );
};


/*******************************/
/** Component(s)              **/
/*******************************/

export const CMSParagraphComponent = (props) => {
    const { content, style } = props;
    return (
        <div dangerouslySetInnerHTML={{ __html: content}} style={style}/>
    ); 
};
